<!-- Collection create and edit  -->
<div class="grow flex items-start justify-center overflow-hidden h-full">
    <!-- Create first collection -->
    <div *ngIf="firstCollection"
        class="w-full max-w-[650px] p-10 m-8 mt-[20vh] flex flex-col items-center gap-3 border border-app-form-field-border rounded-[20px]">
        <mat-icon svgIcon="files" class="w-[50px] h-[50px]"></mat-icon>
        <h2 class="text-3xl font-semibold" i18n>Collecties</h2>
        <p *ngIf="connection.role.value !== 'chatter'" class="text-xl text-center" i18n>
            Begin met het maken van je eerste collectie
        </p>
        <p *ngIf="connection.role.value === 'chatter'" class="text-xl text-center" i18n>
            Er zijn nog geen collecties gemaakt
        </p>
        <button mat-flat-button color="secondary" *ngIf="connection.role.value !== 'chatter'"
            (click)="firstCollection = false" i18n>
            Nieuwe collectie
        </button>
    </div>

    <!-- Create collection -->
    <div class="w-full h-full flex flex-col items-center relative" *ngIf="!firstCollection">

        <!-- Back button on mobile -->
        <button mat-icon-button aria-label="Terug" *ngIf="!breakpoint.md.value"
            class="scale-[0.8] absolute top-2 left-4" routerLink="/collections/{{collection?.id}}">
            <mat-icon svgIcon="arrow-left" class="text-app-global-text-primary shrink-0 scale-[1.2]"></mat-icon>
        </button>


        <!-- Top bar -->
        <div
            class="bg-app-collections-actions-top-bar-background h-16 flex items-center justify-center w-full shrink-0 px-8">
            <div class="flex items-center justify-end md:justify-between grow max-w-[650px] ml-8 md:ml-0">
                <div class="flex gap-4 items-center" *ngIf="breakpoint.md.value">
                    <p class="text-2xl font-bold" i18n>Collectie</p>
                    <p class="text-app-global-text-secondary font-light text-lg italic h-[18px]"
                        *ngIf="mode === 'edit' && breakpoint.xl.value" i18n>
                        Aan het bewerken</p>
                    <p class="text-app-global-text-secondary font-light text-lg italic h-[18px]"
                        *ngIf="mode === 'edit' && !breakpoint.xl.value" i18n>
                        Bewerken</p>
                    <p class="text-app-global-text-secondary font-light text-lg italic h-[18px]" *ngIf="mode === 'new'"
                        i18n>
                        Aanmaken
                    </p>
                </div>

                <div class="flex gap-4 items-center ">
                    <button mat-button class="text-app-global-text-secondary"
                        [routerLink]="'/collections' + (collection ? ('/' + collection.id) : '')" i18n>
                        Annuleren
                    </button>
                    <button mat-flat-button color="primary" class="save-button"
                        (click)="collection ? updateCollection() : saveCollection()" i18n>
                        Opslaan
                    </button>
                </div>
            </div>
        </div>

        <!-- Fields and document upload -->
        <div class="flex flex-col items-center w-full overflow-auto">

            <!-- Processing warning -->
            <div class="flex items-center justify-center w-full max-w-[718px] mt-5 px-8"
                *ngIf="collection?.status === 'processing'">
                <div
                    class="rounded-[15px] bg-app-collections-warning-card-background p-5 flex items-center gap-5 w-full">
                    <mat-icon svgIcon="file-clock" class="w-6 h-6 shrink-0"></mat-icon>
                    <div class="flex flex-col gap-2">
                        <p class="text-base" i18n>
                            De chatbot verwerkt momenteel de collectie. Nieuwe wijzigingen worden verwerkt zodra de
                            huidige
                            zijn voltooid.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Fields -->
            <div class="flex flex-row justify-center pt-5 pb-5 px-8 w-full md:max-w-[718px]">
                <div class="grow flex flex-col items-center gap-5 overflow-x-hidden">
                    <!-- Name -->
                    <div
                        class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                        <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Naam collectie</p>
                        <mat-form-field class="grow w-full sm:max-w-[420px]">
                            <input matInput i18n-placeholder placeholder="Naam collectie"
                                [formControl]="collectionFormGroup.controls.name">
                            <mat-error i18n>Veld is verplicht</mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Description -->
                    <div
                        class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                        <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Omschrijving</p>
                        <mat-form-field class="grow w-full sm:max-w-[420px]">
                            <textarea matInput id="chatInputArea" i18n-placeholder placeholder="Omschrijving"
                                cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"
                                cdkAutosizeMaxRows="7"
                                [formControl]="collectionFormGroup.controls.description"></textarea>
                            <mat-error i18n>Veld is verplicht</mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Private -->
                    <div class="w-full flex flex-col items-start justify-between gap-2">
                        <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Zichtbaarheid</p>

                        <!-- Radio buttons -->
                        <mat-radio-group class="flex flex-col" [formControl]="collectionFormGroup.controls.private">
                            <mat-radio-button [value]="false" i18n>Voor iedereen</mat-radio-button>
                            <mat-radio-button [value]="true" i18n>Alleen voor mij</mat-radio-button>
                        </mat-radio-group>

                    </div>
                    <!-- Documents -->
                    <div class="w-full flex flex-col">
                        <div class="flex flex-row justify-between items-center mb-2 sm:mb-5">
                            <p class="text-base font-semibold" i18n>Documenten</p>
                            <!-- Sorting: Status, A-Z, Created At (Asc Desc) -->
                            <button mat-flat-button *ngIf="true"
                                class="flex flex-row items-center cursor-pointer bg-white text-black"
                                [matMenuTriggerFor]="orderMenu">
                                <mat-icon class="text-black" svgIcon="chevron-down" iconPositionEnd></mat-icon>
                                <ng-container i18n>Sorteren op</ng-container>
                            </button>
                            <mat-menu #orderMenu="matMenu" [xPosition]="'before'">
                                <button mat-menu-item (click)="fileList.switchOrder('title', 'asc')" [ngClass]="{'bg-[#ededed]': fileList.orderColumn
                                     === 'title'}">
                                    <span class="text-base text-black" i18n>Titel</span>
                                </button>
                                <button mat-menu-item (click)="fileList.switchOrder('created_at', 'desc')" [ngClass]="{'bg-[#ededed]': fileList.orderColumn
                                     === 'created_at' && fileList.orderDirection === 'desc'}">
                                    <span class="text-base text-black" i18n>Datum aflopend</span>
                                </button>
                                <button mat-menu-item (click)="fileList.switchOrder('created_at', 'asc')" [ngClass]="{'bg-[#ededed]': fileList.orderColumn
                                     === 'created_at' && fileList.orderDirection === 'asc'}">
                                    <span class="text-base text-black" i18n>Datum oplopend</span>
                                </button>
                                <button mat-menu-item (click)="fileList.switchOrder('status', 'desc')" [ngClass]="{'bg-[#ededed]': fileList.orderColumn
                                     === 'status'}">
                                    <span class="text-base text-black" i18n>Status</span>
                                </button>
                            </mat-menu>
                        </div>

                        <!-- Failed warning with option to retry -->
                        <div class="flex items-center justify-center w-full max-w-[714px] mb-5 mt-[-8px]"
                            *ngIf="showFailedDocumentsWarning">
                            <div
                                class="rounded-[15px] bg-app-collections-warning-card-background p-5 flex items-center gap-5">
                                <mat-icon svgIcon="file-warning"
                                    class="w-6 h-6 shrink-0 text-app-global-warning"></mat-icon>
                                <div class="flex flex-col gap-2">
                                    <p class="text-base" i18n>
                                        Een of meer documenten in deze collectie zijn niet correct verwerkt. Verwijder
                                        deze documenten of klik op de onderstaande knop om ze opnieuw toe te voegen.
                                    </p>
                                    <button mat-stroked-button class="w-fit h-[32px]" i18n
                                        (click)="reselectFailedDocuments()">
                                        Opnieuw toevoegen
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Select -->
                        <file-selector [allowedFileExtensions]="['.pdf', '.docx', '.md']" [multiple]="true"
                            #fileSelector
                            [invalid]="collectionFormGroup.controls.files.hasError('required') && !collectionFormGroup.controls.files.untouched"
                            [dragDropEnabled]="breakpoint.lg.value">
                        </file-selector>

                        <!-- Selected documents -->
                        <file-list [fileSelector]="fileSelector" #fileList
                            [control]="$any(collectionFormGroup.controls.files)" [delete]="true" [view]="false"
                            class="mt-2" [download]="false"></file-list>

                    </div>

                    <!-- Advanced settings -->
                    <expansion-content class="w-full"
                        *ngIf="organization.currentOrganization$.value?.settings?.features?.includes('CollectionAdvancedSettings')">
                        <h2 title i18n>Geavanceerde instellingen</h2>

                        <div class="mt-3 flex flex-col w-full gap-5">
                            <!-- Temperature -->
                            <div
                                class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                                <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Temperature</p>
                                <mat-form-field class="grow w-full sm:max-w-[420px]">
                                    <input matInput placeholder="0.2" type="number"
                                        [formControl]="collectionFormGroup.controls.temperature">
                                    <mat-error *ngIf="collectionFormGroup.controls.temperature.hasError('required')"
                                        i18n>Veld is verplicht</mat-error>
                                    <mat-error *ngIf="collectionFormGroup.controls.temperature.hasError('range')"
                                        i18n>Kies een waarde tussen 0 en 1</mat-error>
                                </mat-form-field>
                            </div>
                            <!-- System prompt -->
                            <div class="w-full flex flex-col items-start justify-between gap-2">
                                <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>System prompt</p>
                                <mat-form-field class="grow w-full ">
                                    <textarea matInput id="chatInputArea" i18n-placeholder placeholder="System prompt"
                                        cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="4"
                                        cdkAutosizeMaxRows="7"
                                        [formControl]="collectionFormGroup.controls.systemPrompt"></textarea>
                                    <mat-error i18n>Veld is verplicht</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </expansion-content>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Dialog to show when user needs to wait on file upload -->
<dynamic-dialog #waitDialog [closeOnBackdropClick]="false" [maxWidth]="620">
    <h1 title i18n>Even geduld...</h1>
    <p class="mb-[-24px]" i18n class="text-center">
        Je bestanden worden op dit moment geüpload en opgeslagen. Afhankelijk van de bestandsgrootte kan dit even duren.
        Zodra het proces is voltooid, word je automatisch doorgestuurd naar je nieuw aangemaakte collectie.
    </p>
    <!-- Hide cancel/confirm buttons -->
    <div cancel-button></div>
    <div confirm-button></div>
</dynamic-dialog>